import initialState from 'store/constants/initial';

import { SegregationType } from './action';
import * as t from './constants';

type SegregateImagesState = typeof initialState.segregateImages;

function setSegregationType(
  state: SegregateImagesState,
  payload: SegregationType
): SegregateImagesState {
  return { ...state, segregationType: payload };
}

function setSplitRatio(
  state: SegregateImagesState,
  payload: number
): SegregateImagesState {
  return { ...state, splitRatio: payload };
}

function setTrainTag(
  state: SegregateImagesState,
  payload: string
): SegregateImagesState {
  return { ...state, trainTag: payload };
}

function setTestTag(
  state: SegregateImagesState,
  payload: string
): SegregateImagesState {
  return { ...state, testTag: payload };
}

function setIsExistingTagModal(
  state: SegregateImagesState,
  payload: boolean
): SegregateImagesState {
  return { ...state, isExistingTagModal: payload };
}

function setIsConfirmationModalOpen(
  state: SegregateImagesState,
  payload: boolean
): SegregateImagesState {
  return { ...state, isConfirmationModalOpen: payload };
}

export function segregateImagesReducer(
  state: SegregateImagesState = initialState.segregateImages,
  action: { type: string; payload: any }
): SegregateImagesState {
  switch (action.type) {
    case t.SET_SEGREGATE_TYPE:
      return setSegregationType(state, action.payload);
    case t.SET_SPLIT_RATIO:
      return setSplitRatio(state, action.payload);
    case t.SET_TRAIN_TAG:
      return setTrainTag(state, action.payload);
    case t.SET_TEST_TAG:
      return setTestTag(state, action.payload);
    case t.SET_IS_EXISTING_TAG_MODAL:
      return setIsExistingTagModal(state, action.payload);
    case t.SET_IS_CONFIRMATION_MODAL_OPEN:
      return setIsConfirmationModalOpen(state, action.payload);
    default:
      return state;
  }
}
